import React, { useState, useEffect } from 'react';
import { Table, Card, Tag, Typography, Space, message } from 'antd';
import { ClockCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { logApi } from '../../services/api';
import dayjs from 'dayjs';

const { Title } = Typography;

const typeColors = {
  '电话': 'blue',
  '微信': 'green',
  '拜访': 'orange',
  '演示': 'purple',
  '报价': 'cyan',
  '成交': 'red',
  '备注': 'default',
};

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await logApi.list();
      setLogs(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      message.error('加载跟进记录失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleDelete = async (id) => {
    try {
      await logApi.delete(id);
      message.success('已删除');
      fetchLogs();
    } catch (err) {
      message.error('删除失败');
    }
  };

  const columns = [
    {
      title: '客户',
      dataIndex: ['customer', 'name'],
      key: 'customer',
      render: (text) => <strong>{text || '-'}</strong>,
    },
    {
      title: '跟进人',
      dataIndex: ['user', 'name'],
      key: 'user',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      render: (type) => <Tag color={typeColors[type] || 'default'}>{type || '-'}</Tag>,
    },
    {
      title: '跟进内容',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
    },
    {
      title: '下一步行动',
      dataIndex: 'nextAction',
      key: 'nextAction',
      render: (text) => text || '-',
    },
    {
      title: '下次跟进日期',
      dataIndex: 'nextDate',
      key: 'nextDate',
      render: (date) => (date ? dayjs(date).format('YYYY-MM-DD') : '-'),
    },
    {
      title: '时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => (
        <Space>
          <ClockCircleOutlined />
          {dayjs(date).format('YYYY-MM-DD HH:mm')}
        </Space>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <a onClick={() => handleDelete(record.id)} style={{ color: '#ff4d4f' }}>
          <DeleteOutlined /> 删除
        </a>
      ),
    },
  ];

  return (
    <Card>
      <Title level={4} style={{ marginBottom: 24 }}>跟进记录</Title>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={logs}
        loading={loading}
        pagination={{ pageSize: 15, showSizeChanger: true }}
      />
    </Card>
  );
}
